<script setup lang="ts">
import { computed } from 'vue';
import UserHeader from '../UserHeader';
import { useRouting } from '@/composables';

const $routing = useRouting();
const isFromAdminRoute = computed<boolean>(() => $routing.route.name === 'administrators.userProfile');
</script>

<template>
  <UserHeader v-if="isFromAdminRoute" />
  <div class="page-content">
    <RouterView />
  </div>
</template>

<style lang="scss" scoped>
.page-content {
  .p-card {
    .p-chip {
      background: var(--primary-color-dark);
      color: white;
      margin-right: 1rem;
    }
  }
}
</style>
